var map = {
	"./chat-icon-bottom-nav-mobile-active.webp": 2697,
	"./chat-icon-bottom-nav-mobile.webp": 2698,
	"./home-icon-bottom-nav-mobile-active.webp": 2699,
	"./home-icon-bottom-nav-mobile-active_b.webp": 2700,
	"./home-icon-bottom-nav-mobile.webp": 2701,
	"./home-icon-bottom-nav-mobile_b.webp": 2702,
	"./me-icon-bottom-nav-mobile-active.webp": 2703,
	"./me-icon-bottom-nav-mobile.webp": 2704,
	"./promo-icon-bottom-nav-mobile-active.webp": 2705,
	"./promo-icon-bottom-nav-mobile.webp": 2706,
	"./sponsor-icon-bottom-nav-mobile-active.webp": 2707,
	"./sponsor-icon-bottom-nav-mobile.webp": 2708,
	"./stream-icon-bottom-nav-mobile-active.webp": 2709,
	"./stream-icon-bottom-nav-mobile.webp": 2710
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2696;